<template>
  <PageWrapper
    :active-section="SECTION_COMMUNITY"
    :active-page="PAGE_ACTIVE_NETWORKS"
    title="Browse All"
    :breadcrumbs="breadcrumbs"
    page-name="Browse All"
    align="center"
    width="full"
    action-button-text="Create New Network"
    @click:action="submitOpenNetworkModal"
  >
    <SmartFeed
      :source="useCommunityNetworkFeedStore"
      load-more-behavior="auto"
    />
    <NetworkModal />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import { SECTION_COMMUNITY, PAGE_ACTIVE_NETWORKS } from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import { useCommunityNetworkFeedStore } from "@/smart-feed/stores/feed/community-network-feed-store";
import NetworkModal from "@/components/networks/NetworkModal.vue";
import { mapActions } from "pinia";
import { useNetworkStore } from "@/stores/network-store";

export default {
  name: "ActiveNetworks",
  components: {
    SmartFeed,
    NetworkModal,
    PageWrapper,
  },
  data() {
    return {
      SECTION_COMMUNITY,
      PAGE_ACTIVE_NETWORKS,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: "/community", label: "Community" },
      ];
    },
  },
  methods: {
    useCommunityNetworkFeedStore,
    ...mapActions(useNetworkStore, ["openNetworkModal"]),
    submitOpenNetworkModal() {
      this.openNetworkModal();
    },
  },
};
</script>
